export default __webpack_public_path__ + "static/media/0x45c32fa6df82ead1e2ef74d17b76547eddfaff89.06ed0d51.webp";